import React from "react";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import TalkToUsBackground from "../../assets/images/talktous-background-homepage.png";

const PREFIX = "TalktoUs";
const classes = {
  mainGrid: `${PREFIX}-mainGrid`,
  mainHeadingGrid: `${PREFIX}-mainHeadingGrid`,
  mainHeading: `${PREFIX}-mainHeading`,
  mainTalkDescriptionGrid: `${PREFIX}-mainTalkDescriptionGrid`,
  talkDescriptionGrid: `${PREFIX}-talkDescriptionGrid`,
  talkDescriptionStyle: `${PREFIX}-talkDescriptionStyle`,
  bookButtonGrid: `${PREFIX}-bookButtonGrid`,
  bookDemoButton: `${PREFIX}-bookDemoButton`,
  lineStyle: `${PREFIX}-lineStyle`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.mainGrid}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    marginTop: "1%",
    textAlign: "center",
  },
  [`& .${classes.mainHeadingGrid}`]: {
    display: "flex",
    fontFamily: "AvenirLTStd-Roman",
    paddingTop: "0rem",
    paddingBottom: "1rem",
    backgroundSize: "contain",
    justifyContent: "center",
  },
  [`& .${classes.mainHeading}`]: {
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 40,
    [theme.breakpoints.down("sm")]: {
      fontSize: 30,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 35,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 40,
    },
  },
  [`& .${classes.mainTalkDescriptionGrid}`]: {
    padding: "1rem",
    fontFamily: "AvenirLTStd-Book",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  [`& .${classes.talkDescriptionGrid}`]: {
    display: "flex",
    fontFamily: "AvenirLTStd-Book",
    flexDirection: "column",
    alignItems: "center",
    fontSize: 25,
    width: "100%",
    maxWidth: 900,
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
      width: "100%",
    },
  },
  [`& .${classes.bookButtonGrid}`]: {
    paddingTop: "0.5rem",
    textAlign: "center",
    position: "relative", // Ensure the pseudo-element is positioned relative to this grid
  },
  [`& .${classes.bookDemoButton}`]: {
    background: "#B41E1C",
    color: "#fff",
    textTransform: "capitalize",
    fontFamily: "AvenirLTStd-Roman",
    marginTop: "2em",
    fontWeight: "none",
    borderRadius: "24px",
    fontSize: 15,
    width: 250,
    [theme.breakpoints.down("sm")]: {
      width: 300,
      fontSize: "0.9rem",
      marginLeft: 0,
    },
  },
  [`& .${classes.lineStyle}`]: {
    position: "relative",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    "&::after": {
      content: '""',
      display: "block",
      width: "50%", 
      height: "1px",
      backgroundColor: "#DCDCDC", 
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
    },
  },
}));

const TalktoUs = () => {
  return (
    <StyledGrid container>
      <Grid size={{ xs: 12 }}>
        <Grid container className={classes.mainGrid}>
          <Grid size={{ xs: 12 }} className={classes.mainHeadingGrid}>
            <Typography className={classes.mainHeading}>Talk to Us</Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Grid container className={classes.mainTalkDescriptionGrid}>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Typography className={classes.talkDescriptionGrid}>
                  Schedule a no-obligation, 15-minute call at your convenience
                  to learn more and discover how our software can benefit your
                  operations.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12 }} className={classes.bookButtonGrid}>
            <Button
              variant="contained"
              href="https://calendly.com/redifly/discoverycall"
              target="_blank"
              color="primary"
              className={classes.bookDemoButton}
            >
              Schedule a Discovery Call
            </Button>
          </Grid>
          <Grid size={{ xs: 12 }} className={classes.lineStyle}></Grid>
        </Grid>
      </Grid>
    </StyledGrid>
  );
};

export default TalktoUs;
